import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';

import { FormData } from '../helpers/FormData';
import { _adminUserUpsert, _adminUserGetById } from '../services/apiConnections.service';

export const AdminUserUpsert = (props) => {

    const [token, setToken] = useState(null);
    const [error, setError] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [formValues, handleFormValueChange, setFormValues] = FormData({
        email: '',
        first_name: '',
        last_name: '',
        password: '',
        confirm_password: '',
        status: 'active' // Default to 'active'
    });
    const [formErrors, setFormErrors] = useState({});

    let navigate = useNavigate();
    let params = useParams();

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        setToken(storedToken);
    }, []);

    useEffect(() => {
        if (token && props.edit) {
            handleUserGet();
        }
    }, [token, props]);

    const handleUserGet = async () => {
        if (!token) return;
        let result = await _adminUserGetById(token, params.id);
        if (result.error) {
            console.log("--error: ", result.error);
        } else {
            setFormValues({
                'email': result.email,
                'first_name': result.first_name,
                'last_name': result.last_name,
                'status': result.status || 'active' // Set status from API response
            })
        }
        setError(result.error);
    };

    const handleUpsert = async (event) => {
        event.preventDefault();
        let result;

        result = await _adminUserUpsert(token, formValues, props.edit ? params.id : '');

        console.log("result", result)

        if (result.error) {
            setError(result.error);
        } else {
            toast.success(props.edit ?
                `Your changes in admin user information were saved successfully`
                :
                `Admin user was successfully created`);
            navigate('/admin-users');
        }
    };

    const handleCancel = () => {
        navigate('/admin-users');
    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const handleValidation = (target) => {
        switch (target.name) {
            case 'email':
                if (!target.value.length) {
                    setFormErrors(formErrors => ({
                        ...formErrors,
                        email: "Email Is Required"
                    }));
                } else if (target.value && !validateEmail(target.value)) {
                    let copy = { ...formErrors };
                    delete copy['email'];
                    setFormErrors(copy);
                    setFormErrors(formErrors => ({
                        ...formErrors,
                        email: "Email Is Invalid"
                    }));
                } else {
                    let copy = { ...formErrors };
                    delete copy['email'];
                    setFormErrors(copy);
                }
                break;
            case 'first_name':
                if (!target.value.length) {
                    setFormErrors(formErrors => ({
                        ...formErrors,
                        first_name: "First Name Is Required"
                    }));
                } else {
                    let copy = { ...formErrors };
                    delete copy['first_name'];
                    setFormErrors(copy);
                }
                break;
            case 'last_name':
                if (!target.value.length) {
                    setFormErrors(formErrors => ({
                        ...formErrors,
                        last_name: "Last Name Is Required"
                    }));
                } else {
                    let copy = { ...formErrors };
                    delete copy['last_name'];
                    setFormErrors(copy);
                }
                break;
            case 'password':
                if (target.value != formValues.confirm_password) {
                    setFormErrors(formErrors => ({
                        ...formErrors,
                        confirm_password: "Must Match Your New Password"
                    }));
                } else {
                    let copy = { ...formErrors };
                    delete copy['confirm_password'];
                    setFormErrors(copy);
                }
                break;
            case 'confirm_password':
                if (target.value != formValues.password) {
                    setFormErrors(formErrors => ({
                        ...formErrors,
                        confirm_password: "Must Match Your New Password"
                    }));
                } else {
                    let copy = { ...formErrors };
                    delete copy['confirm_password'];
                    setFormErrors(copy);
                }
                break;
            default: break;
        }
    };

    const formIsValid = () => {
        return !Object.keys(formErrors).length && formValues.email.length && formValues.first_name.length && formValues.last_name.length &&
            (!props.edit ? formValues.password.length && formValues.confirm_password.length : true);
    };

    return (
        <div className='content'>
            <div>
                <div className='pageTitle'>
                    <span>{!props.edit ? 'Create Admin User' : 'Edit Admin User'}</span>
                </div>
                {error && <p className='msgBlock errorMsg'>{error}</p>}
                <div className='pageContent'>
                    <div className="mb-3" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div className='checkboxBlockedWrapper'>
                            <label className='checkboxContainer'>
                                <input
                                    id='status'
                                    name='status'
                                    type="checkbox"
                                    className='formCheckbox'
                                    checked={formValues.status === 'blocked'}
                                    onChange={(event) => {
                                        handleFormValueChange(
                                            'status',
                                            event.target.checked ? 'blocked' : 'active'
                                        );
                                    }}
                                />
                                <span className='checkmark'></span>
                            </label>
                            <label
                                className='inputLabel'
                                htmlFor='status'>Blocked</label>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label
                            className='inputLabel requiredInput'
                            htmlFor='email'>Email</label>
                        <div className='inputWrapper'>
                            <input
                                id='email'
                                name='email'
                                type="text"
                                className={`formInput`}
                                placeholder="Email"
                                value={formValues.email}
                                required
                                onChange={(event) => {
                                    handleFormValueChange(
                                        'email',
                                        event.target.value
                                    )
                                }}
                                onKeyUp={(event) => { handleValidation(event.target) }}
                            />
                            <span className='fieldError'>{formErrors.email}</span>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label
                            className='inputLabel requiredInput'
                            htmlFor='first_name'>First Name</label>
                        <div className='inputWrapper'>
                            <input
                                id='first_name'
                                name='first_name'
                                type="text"
                                className={`formInput ${formErrors.first_name ? 'invalidInput' : ''}`}
                                placeholder="First Name"
                                value={formValues.first_name}
                                required
                                onChange={(event) => {
                                    handleFormValueChange(
                                        'first_name',
                                        event.target.value
                                    )
                                }}
                                onKeyUp={(event) => { handleValidation(event.target) }}
                            />
                            <span className='fieldError'>{formErrors.first_name}</span>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label
                            className='inputLabel requiredInput'
                            htmlFor='last_name'>Last Name</label>
                        <div className='inputWrapper'>
                            <input
                                id='last_name'
                                name='last_name'
                                type="text"
                                className={`formInput ${formErrors.last_name ? 'invalidInput' : ''}`}
                                placeholder="Last Name"
                                required
                                value={formValues.last_name}
                                onChange={(event) => {
                                    handleFormValueChange(
                                        'last_name',
                                        event.target.value
                                    )
                                }}
                                onKeyUp={(event) => { handleValidation(event.target) }}
                            />
                            <span className='fieldError'>{formErrors.last_name}</span>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label
                            className={`inputLabel ${!props.edit ? 'requiredInput' : ''}`}
                            htmlFor='password'>New Password</label>
                        <div className='inputWrapper'>
                            <input
                                id='password'
                                name='password'
                                type="password"
                                className={`formInput ${formErrors.password ? 'invalidInput' : ''}`}
                                placeholder="Password"
                                autoComplete='new-password'
                                required={!props.edit}
                                value={formValues.password}
                                onChange={(event) => {
                                    handleFormValueChange(
                                        'password',
                                        event.target.value
                                    )
                                }}
                                onKeyUp={(event) => { handleValidation(event.target) }}
                            />
                            <span className='fieldError'>{formErrors.password}</span>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label
                            className={`inputLabel ${!props.edit ? 'requiredInput' : ''}`}
                            htmlFor='confirm_password'>Confirm Password</label>
                        <div className='inputWrapper'>
                            <input
                                id='confirm_password'
                                name='confirm_password'
                                type="password"
                                className={`formInput ${formErrors.confirm_password ? 'invalidInput' : ''}`}
                                placeholder="Confirm Password"
                                required={!props.edit}
                                value={formValues.confirm_password}
                                onChange={(event) => {
                                    handleFormValueChange(
                                        'confirm_password',
                                        event.target.value
                                    )
                                }}
                                onKeyUp={(event) => { handleValidation(event.target) }}
                            />
                            <span className='fieldError'>{formErrors.confirm_password}</span>
                        </div>
                    </div>
                    <div className='buttonBlock'>
                        <button
                            onClick={handleCancel}
                            className='mainBtn btn marginR15'>Cancel</button>
                        <button
                            onClick={handleUpsert}
                            className={`mainBtn btn ${formIsValid() ? '' : 'disabledBtn'}`}
                            disabled={!formIsValid()}>Save</button>
                    </div>
                </div>
            </div>
            <Toaster />
        </div >
    );
};